import React from "react";

function Header() {
  return (
    <div id="tt-header" className="tt-header-fixed">
      <div className="tt-header-inner">
        <div className="tt-header-col">
          <div className="tt-logo">
            <a href="/">
              <img
                src="assets/img/logo-light.png"
                className="tt-logo-light magnetic-item"
                alt="Logo"
              />
              <img
                src="assets/img/logo-light.png"
                className="tt-logo-dark magnetic-item"
                alt="Logo"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;